module.exports = __webpack_public_path__ + "static/massonSculpture-e0c995bf806d6c9ea406e87611ba92f9.png";